export const local_config = {
    external_auth_url: 'https://www.ciaobnb.com/academy_authentication?callback=/login',
    // external_auth_url: 'http://local.ciaotest.com/academy_authentication?callback=/login'
};
